import { createHttpLink } from '@apollo/client';
import { getServerURL } from 'src/modules/debug/utils';
// ponytail: resolve URL per request — module-level getServerURL() can snapshot
// undefined under New Arch before UltimateConfig/fallback is readable.
const httpLink = createHttpLink({
    uri: ({ operationName }) => `${getServerURL()}/graphql?opName=${operationName}`,
});
export default httpLink;
